import React from 'react'
import { Helmet } from 'react-helmet'

import StaticScene from '../StaticScene/StaticScene'

const NotFoundScene = () => (
  <StaticScene>
    <Helmet>
      <title>Page Not Found (404) - {process.env.REACT_APP_SITE_TITLE}</title>
    </Helmet>

    <h1 className="mt-5 text-center">Page Not Found</h1>
    <p className="mb-5 text-center">We could not find the page you were looking for.</p>
  </StaticScene>
)

export default NotFoundScene


// WEBPACK FOOTER //
// ./src/components/NotFoundScene/NotFoundScene.js